const UPDATE_FRED_SERIES = 'UPDATE_FRED_SERIES';
const UPDATE_FRED_FREQUENCY = 'UPDATE_FRED_FREQUENCY';
const UPDATE_FRED_START = 'UPDATE_FRED_START';
const UPDATE_FRED_END = 'UPDATE_FRED_END';
const UPDATE_FRED_UNITS = 'UPDATE_FRED_UNITS';
const UPDATE_FRED_MOVING = 'UPDATE_FRED_MOVING';
const UPDATE_FRED_METHOD = 'UPDATE_FRED_METHOD';
const UPDATE_BLS_PRESET = 'UPDATE_BLS_PRESET';
const UPDATE_BLS_SERIES = 'UPDATE_BLS_SERIES';
const UPDATE_BLS_START = 'UPDATE_BLS_START';
const UPDATE_BLS_END = 'UPDATE_BLS_END';
const UPDATE_BLS_CALCULATIONS = 'UPDATE_BLS_CALCULATIONS';
const UPDATE_BLS_MONTHS = 'UPDATE_BLS_MONTHS';
const UPDATE_BLS_MOVING = 'UPDATE_BLS_MOVING';
const SHOW_BLS_MESSAGE = 'SHOW_BLS_MESSAGE';
const UPDATE_BLS_ERROR = 'UPDATE_BLS_ERROR';
const MUST_RENDER_FALSE = 'MUST_RENDER_FALSE';

function mustRenderFalse(payload) {
  return { type: MUST_RENDER_FALSE, payload };
}

function updateFredSeries(payload) {
  return { type: UPDATE_FRED_SERIES, payload };
}

function updateFredFrequency(payload) {
  return { type: UPDATE_FRED_FREQUENCY, payload };
}

function updateFredUnits(payload) {
  return { type: UPDATE_FRED_UNITS, payload };
}

function updateFredMoving(payload) {
  return { type: UPDATE_FRED_MOVING, payload };
}

function updateFredStart(payload) {
  return { type: UPDATE_FRED_START, payload };
}

function updateFredEnd(payload) {
  return { type: UPDATE_FRED_END, payload };
}

function updateFredMethod(payload) {
  return { type: UPDATE_FRED_METHOD, payload };
}

function updateBLSPreset(payload) {
  return { type: UPDATE_BLS_PRESET, payload };
}

function updateBLSSeries(payload) {
  return { type: UPDATE_BLS_SERIES, payload };
}

function updateBLSStart(payload) {
  return { type: UPDATE_BLS_START, payload };
}

function updateBLSEnd(payload) {
  return { type: UPDATE_BLS_END, payload };
}

function updateBLSCalculations(payload) {
  return { type: UPDATE_BLS_CALCULATIONS, payload };
}

function updateBLSMonths(payload) {
  return { type: UPDATE_BLS_MONTHS, payload };
}

function updateBLSMoving(payload) {
  return { type: UPDATE_BLS_MOVING, payload };
}

function toggleBLSMessage(payload) {
  return { type: SHOW_BLS_MESSAGE, payload };
}

function updateBLSError(payload) {
  return { type: UPDATE_BLS_ERROR, payload };
}

export {
  UPDATE_FRED_SERIES,
  UPDATE_FRED_FREQUENCY,
  UPDATE_FRED_START,
  UPDATE_FRED_END,
  UPDATE_FRED_UNITS,
  UPDATE_FRED_MOVING,
  UPDATE_FRED_METHOD,
  UPDATE_BLS_PRESET,
  UPDATE_BLS_SERIES,
  UPDATE_BLS_START,
  UPDATE_BLS_END,
  UPDATE_BLS_CALCULATIONS,
  UPDATE_BLS_MONTHS,
  UPDATE_BLS_MOVING,
  SHOW_BLS_MESSAGE,
  UPDATE_BLS_ERROR,
  MUST_RENDER_FALSE,
  mustRenderFalse,
  updateFredSeries,
  updateFredFrequency,
  updateFredUnits,
  updateFredMoving,
  updateFredStart,
  updateFredEnd,
  updateFredMethod,
  updateBLSPreset,
  updateBLSSeries,
  updateBLSStart,
  updateBLSEnd,
  updateBLSCalculations,
  updateBLSMonths,
  updateBLSMoving,
  toggleBLSMessage,
  updateBLSError,
};
